import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import PlainDDComponent from "../../DropDown/normalDD";
import API from "../../../services/api.service";
import { APIS } from "../../../constants/apis";
import { notification, Modal, Input, Button } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

interface Contact {
  id?: number;
  name: string;
  description: string;
  phone: string;
  email: string;
}
const EMPTY: Contact = { name: "", description: "", phone: "", email: "" };
const lbl: any = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#6b7a72",
  margin: "14px 0 6px",
};

const SettingContact = () => {
  const [dropData, setDropData] = useState<any>([]);
  const [resetAll, setresetAll] = useState(false);
  let defaultData = {
    subject: "Property",
    content: "",
  };
  const [data, setData] = useState({ ...defaultData });

  // ----- support contacts (help-contact API, drive the app's Help & Support) -----
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [canEdit, setCanEdit] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState<Contact>({ ...EMPTY });
  const [saving, setSaving] = useState(false);

  const fetchContacts = async () => {
    try {
      const res = await API.get(APIS.HELP_CONTACT.LIST);
      if (res.data.status === 1) {
        setContacts(res.data.data || []);
        setCanEdit(!!res.data.can_edit);
      }
    } catch (e) {
      // silent
    }
  };

  const getContact = async () => {
    const res = await API.get(APIS.PROPERTY_PARAMS.CONTACT);
    let data = Object.values(res.data.data);
    setDropData(data);
  };

  const sendFeedback = async () => {
    if (data.subject != "") {
      const res = await API.post(APIS.SETTING.SEND_FEEDBACK, data);
      if (res.data.status === 1) {
        onCancel();

        notification.success({
          message: res.data.message || "FeedBack Sended",
          placement: "topRight",
        });
      } else {
        notification.error({
          message: res.data.message || "Sorry Failed To Send FeedBack",
          placement: "topRight",
        });
      }
    }
  };

  const onCancel = () => {
    setData(defaultData);
    setresetAll(true);
  };

  useEffect(() => {
    getContact();
    fetchContacts();
  }, []);

  const openAdd = () => {
    setEditing({ ...EMPTY });
    setEditOpen(true);
  };
  const openEdit = (c: Contact) => {
    setEditing({ ...c });
    setEditOpen(true);
  };

  const saveContact = async () => {
    if (!editing.name.trim()) {
      notification.error({ message: "Name is required", placement: "topRight" });
      return;
    }
    const body = {
      name: editing.name,
      description: editing.description,
      phone: editing.phone,
      email: editing.email,
    };
    try {
      setSaving(true);
      const res = editing.id
        ? await API.put(APIS.HELP_CONTACT.UPDATE + editing.id, body)
        : await API.post(APIS.HELP_CONTACT.ADD, body);
      if (res.data.status === 1) {
        notification.success({
          message: editing.id ? "Contact updated" : "Contact added",
          placement: "topRight",
        });
        setEditOpen(false);
        fetchContacts();
      } else {
        notification.error({
          message: res.data.message || "Could not save contact",
          placement: "topRight",
        });
      }
    } catch (e: any) {
      notification.error({
        message: e?.response?.data?.message || "Something went wrong",
        placement: "topRight",
      });
    } finally {
      setSaving(false);
    }
  };

  const deleteContact = (c: Contact) => {
    Modal.confirm({
      title: `Delete “${c.name}”?`,
      okText: "Delete",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const res = await API.delete(APIS.HELP_CONTACT.DELETE + c.id);
          if (res.data.status === 1) {
            notification.success({
              message: "Contact deleted",
              placement: "topRight",
            });
            fetchContacts();
          } else {
            notification.error({
              message: res.data.message || "Could not delete",
              placement: "topRight",
            });
          }
        } catch (e) {
          notification.error({
            message: "Something went wrong",
            placement: "topRight",
          });
        }
      },
    });
  };

  return (
    <div className={style.setting_contact_section}>
      <div className={style.left}>
        <div className={style.data_section}>
          <div className={style.header}>
            <img src="/images/phone.svg" alt="" />
            Support contacts
          </div>
          <div className={style.data_body}>
            {contacts.length === 0 && (
              <div
                className={style.data}
                style={{ padding: 16, opacity: 0.6, fontSize: 15 }}
              >
                No contacts yet.
              </div>
            )}
            {contacts.map((c) => (
              <div
                key={c.id}
                className={style.data_details}
                style={{ alignItems: "flex-start" }}
              >
                <div>
                  <div className={style.data}>{c.name}</div>
                  {c.description && (
                    <div
                      style={{
                        fontSize: 14,
                        color: "#6b7a72",
                        marginTop: 4,
                      }}
                    >
                      {c.description}
                    </div>
                  )}
                  {c.phone && (
                    <div style={{ fontSize: 15, marginTop: 8 }}>
                      📞 {c.phone}
                    </div>
                  )}
                  {c.email && (
                    <div style={{ fontSize: 15, marginTop: 2 }}>
                      ✉️ {c.email}
                    </div>
                  )}
                </div>
                {canEdit && (
                  <div style={{ display: "flex", gap: 14, fontSize: 18 }}>
                    <EditOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => openEdit(c)}
                    />
                    <DeleteOutlined
                      style={{ cursor: "pointer", color: "#c0392b" }}
                      onClick={() => deleteContact(c)}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
          {canEdit && (
            <Button
              icon={<PlusOutlined />}
              onClick={openAdd}
              style={{ marginTop: 16 }}
            >
              Add contact
            </Button>
          )}
        </div>
        <div className={style.social_connection}>
          <a href="https://www.facebook.com/yours.second.homes/" target="_blank">
            <img src="/images/settings/Facebook.svg" alt="" />{" "}
          </a>
          <a href="https://www.linkedin.com/company/yours-second-homes/about/" target="_blank">
            <img src="/images/settings/Linkedin.svg" alt="bell-icon" />
          </a>
          <a href="https://www.instagram.com/yours_second_homes/" target="_blank">
            <img src="/images/settings/Instagram.svg" alt="" />
          </a>
        </div>
      </div>
      <div className={style.right}>
        <div className={style.msg_box_container}>
          <div className={style.header}>You can also reach us by leaving a message here.</div>
          <div className={style.category_select_dd}>
            <PlainDDComponent
              width={"100%"}
              reset={resetAll}
              setReset={setresetAll}
              data={dropData}
              getData={(res: any) => {
                let newData = { ...data };
                newData.subject = res;
                setData(newData);
              }}
            />
          </div>
          <textarea
            className={style.msg_text_area}
            value={data.content}
            placeholder="Add your Message"
            onChange={(e) => {
              let newData = { ...data };
              newData.content = e.target.value;
              setData(newData);
            }}
          ></textarea>
          <div className={style.action_btn_container}>
            <div className={style.action_btn} onClick={onCancel}>
              Cancel
            </div>
            <div className={style.action_btnblk} onClick={sendFeedback}>
              Send
            </div>
          </div>
        </div>
      </div>

      {/* add / edit contact */}
      <Modal
        visible={editOpen}
        onCancel={() => setEditOpen(false)}
        footer={null}
        destroyOnClose
      >
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          {editing.id ? "Edit contact" : "Add contact"}
        </div>
        <p style={{ color: "#6b7a72", marginBottom: 4 }}>
          Shown to owners on the app's Help &amp; Support screen.
        </p>
        <label style={lbl}>Name *</label>
        <Input
          value={editing.name}
          placeholder="e.g. Deepti"
          onChange={(e) => setEditing({ ...editing, name: e.target.value })}
        />
        <label style={lbl}>Description</label>
        <Input.TextArea
          rows={2}
          value={editing.description}
          placeholder="e.g. To seek answers regarding properties & bookings"
          onChange={(e) =>
            setEditing({ ...editing, description: e.target.value })
          }
        />
        <label style={lbl}>Phone</label>
        <Input
          value={editing.phone}
          placeholder="e.g. +91 9880775551"
          onChange={(e) => setEditing({ ...editing, phone: e.target.value })}
        />
        <label style={lbl}>Email</label>
        <Input
          value={editing.email}
          placeholder="e.g. reachus@yours.house"
          onChange={(e) => setEditing({ ...editing, email: e.target.value })}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20,
          }}
        >
          <Button onClick={() => setEditOpen(false)}>Cancel</Button>
          <Button
            type="primary"
            loading={saving}
            onClick={saveContact}
            style={{ background: "#082017", borderColor: "#082017" }}
          >
            Save
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default SettingContact;
